<template>
  <div class="message" v-html="message"/>
</template>

<script>
export default {
  props: {
    message: {
      required: true,
      type: String
    }
  },
  name: "Message"
}
</script>

<style scoped>
.message {
  background-color: #009688 ;
  width: auto;
  color: white;
  text-align: left;
  word-wrap: break-word;
  margin-top: 10px;
  border: 10px solid var(--teal-color);
  border-radius: 16px;
  padding: 10px 20px 10px 20px;
}
</style>
